import { InfoIcon } from 'lucide-react-native';

import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

export type NpiConflictInfoBoxLoginProps = {
  maskedEmail: string;
};

/**
 * Info box component for displaying NPI conflict information on the login screen.
 * Shows when there's an account linking context, informing the user about the NPI association.
 */
export function NpiConflictInfoBoxLogin({ maskedEmail }: NpiConflictInfoBoxLoginProps) {
  return (
    <VStack className="mb-6 rounded-md bg-background-info px-4 py-4">
      <HStack className="items-start gap-2.5">
        {/* Info Icon */}
        <Icon as={InfoIcon} className="mt-1 h-[18px] w-[18px] text-info-800" />

        {/* Content */}
        <VStack className="flex-1 gap-2">
          {/* Description */}
          <Text size="xs" className="text-typography-900">
            We found an account using {maskedEmail} linked to this NPI. Sign in to continue, once
            verified, your NPI will be automatically linked to this account.
          </Text>
        </VStack>
      </HStack>
    </VStack>
  );
}
